import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=c747efe6&scoped=true&"
import script from "./Headers.vue?vue&type=script&lang=js&"
export * from "./Headers.vue?vue&type=script&lang=js&"
import style0 from "./Headers.vue?vue&type=style&index=0&id=c747efe6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c747efe6",
  null
  
)

export default component.exports